'use strict'

import $ from 'jquery'

export default class LogoGrid{
  constructor(el) {
    this.$el = $(el)

    function ariaDesktop(){
      // Set aria-hidden to true
      $('.logo-grid__button').attr('aria-hidden', true)
      // On hover, set aria-hidden to false
      $('.logo-grid').on('mouseenter', function() {
        $('.logo-grid__button').attr('aria-hidden', false)
      })
      // When exiting, reset aria-hidden to true
      $('.logo-grid').on('mouseleave', function() {
        $('.logo-grid__button').attr('aria-hidden', true)
      })
    }

    function ariaMobile() {
      $('.logo-grid__button').attr('aria-hidden', false)
    }

    // Set aria-hidden value on pageload
    $(document).ready(function() {
      if ($(window).width() >= 800){	
        // If screensize is $large-tablet or above, set aria-hidden to true
        ariaDesktop()
      }	else if ($(window).width() <= 799){	
        // If screensize is below $large-tablet breakpoint, set aria-hidden to false
        ariaMobile()
      }
    })
  } 
}
